export default "__VITE_ASSET__C0A6Uiad__"